import { ThemedMemeGeneratedResponse } from '@supermeme-ai/types'
import axios from 'axios'

export const generateThemedTemplateMeme = async (
  accessToken: string,
  imageName: string,
  memeTheme: string,
  maxDimension: number,
  inputLanguage: string,
  outputLanguage: string,
  imageDescription: string,
  originalDescription?: string
): Promise<ThemedMemeGeneratedResponse> => {
  const response = await axios.post<{ response: ThemedMemeGeneratedResponse }>(
    '/api/meme/themed/template',
    {
      imageName,
      memeTheme,
      maxDimension,
      inputLanguage,
      outputLanguage,
      imageDescription,
      originalDescription,
    },
    {
      headers: {
        token: accessToken,
      },
    }
  )

  return response.data.response
}
